export class NetworskDownloadData {
    id_network: number;
    network_code: string;
    tab_id: number;
    name: string;
    selected: boolean;
    file_id: number;
    path: string;
}